import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home/index.jsx";
import Contact from "./pages/Contact/index.jsx";
import Header from "./components/Header/index.jsx";
import Projects from "./pages/Projects/index.jsx";
import Resume from "./pages/Resume/index.jsx";
import ManufacturingResume from "./pages/Resume/ManufacturingResume.jsx";
import SoftwareResume from "./pages/Resume/SoftwareResume.jsx";
import About from "./pages/About/index.jsx";
import Blog from "./pages/Blog/index.jsx";
import Spine from "./components/Spine/index.jsx";
import ProjectDetailsSpace from "./components/ProjectDetailsSpace/index.jsx";

function App() {
  // eslint-disable-next-line no-unused-vars
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const links = document.querySelectorAll("a");
    links.forEach((el) =>
      el.addEventListener("click", () => window.ga("send", "pageview", el.href))
    );

    console.log("rendered");

    return () => {
      links.forEach((el) =>
        el.removeEventListener("click", () =>
          window.ga("send", "pageview", el.href)
        )
      );
    };
  }, []);

  // document
  //   .querySelectorAll("a")
  //   .forEach((el) =>
  //     el.addEventHandler("click", () =>
  //       window.ga("send", "pageview", el.innerText)
  //     )
  //   );

  return (
    <Router>
      <Header></Header>
      <main>
        <Spine></Spine>

        <div className="content">
          {/* <div id="window-width-tracker">
            Window Width With Spine: {windowWidth}px
          </div> */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetailsSpace />} />
            <Route path="/resume" element={<Resume />} />
            <Route
              path="resume/manufacturing-resume"
              element={<ManufacturingResume />}
            />
            <Route path="resume/software-resume" element={<SoftwareResume />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </div>
      </main>
      {/* <footer></footer> */}
    </Router>
  );
}

export default App;
